(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-header"] && !Shopify.designMode) return;
  try {
    
 class PcHeader extends HTMLElement {
  connectedCallback() {
   this._isPdp = this.dataset.pdp === 'true'
         || document.body.classList.contains('template-product')
         || /\/products\//.test(window.location.pathname);
   if (this._isPdp && !this.classList.contains('pc-header--pdp')) {
    this.classList.add('pc-header--pdp');
   }
   this._mqMobile = window.matchMedia('(max-width: 989px)');
   this._lastY = window.scrollY;
   this._ticking = false;
   const DIR_THRESHOLD = 4;
   const TOP_BAND = 80;
   const AT_TOP_THRESHOLD = 30;

   this._headerGroup = document.getElementById('header-group');
   this._announceBar = document.querySelector('.pc-announce')
            || document.querySelector('#shopify-section-pc_announce');

   const updateBodyState = () => {
    const active = this._isPdp && this._mqMobile.matches;
    document.body.classList.toggle('pc-pdp-mobile', active);
    // offsetHeight is the element's own box height, independent of position
    // and scroll. The previous "rect.bottom + scrollY" approach broke when
    // the bar was inside a position:fixed ancestor (bounding-rect returns
    // viewport coords there, so adding scrollY inflated the value).
    if (active && this._announceBar) {
     const h = this._announceBar.offsetHeight || 0;
     if (h > 0) document.body.style.setProperty('--pc-announce-h', h + 'px');
    }
   };
   updateBodyState();
   if (this._mqMobile.addEventListener) {
    this._mqMobile.addEventListener('change', updateBodyState);
   }
   this._updateBodyState = updateBodyState;

   const findHeroImage = () => {
    let img = document.querySelector('slideshow-component img');
    if (img) return img;
    const candidates = document.querySelectorAll('#MainContent img, main img');
    for (const c of candidates) {
     const r = c.getBoundingClientRect();
     if (r.height > 150) return c;
    }
    return candidates[0] || null;
   };
   this._heroImg = findHeroImage();
   if (!this._heroImg && this._isPdp) {
    setTimeout(() => {
     this._heroImg = findHeroImage();
     if (this._heroImg && this._heroImg.addEventListener) {
      this._heroImg.addEventListener('load', () => this._onScroll(), { once: true });
     }
     this._onScroll();
    }, 500);
   } else if (this._heroImg && this._heroImg.addEventListener) {
    this._heroImg.addEventListener('load', () => this._onScroll(), { once: true });
   }

   this._onScroll = () => {
    if (this._ticking) return;
    this._ticking = true;
    requestAnimationFrame(() => {
     const y = window.scrollY;
     const dy = y - this._lastY;
     const pdpMobile = this._isPdp && this._mqMobile.matches;

     this.classList.toggle('is-scrolled', y > 8);
     document.body.classList.toggle('pc-at-top', y < AT_TOP_THRESHOLD);

     if (pdpMobile && this._heroImg) {
      const rect = this._heroImg.getBoundingClientRect();
      const wrapperBottom = this._headerGroup
       ? this._headerGroup.getBoundingClientRect().bottom
       : this.getBoundingClientRect().bottom;
      const heroNotReady = rect.height < 50;
      const behindHero = heroNotReady || rect.bottom > (wrapperBottom - 20);
      this.classList.toggle('is-solid', !behindHero);
     } else {
      this.classList.remove('is-solid');
     }

     let setHidden, setShown;
     if (pdpMobile && this._headerGroup) {
      setHidden = () => {
       this._headerGroup.classList.add('is-hidden');
       this.classList.add('is-hidden');
      };
      setShown = () => {
       this._headerGroup.classList.remove('is-hidden');
       this.classList.remove('is-hidden');
      };
     } else {
      setHidden = () => this.classList.add('is-hidden');
      setShown = () => {
       this.classList.remove('is-hidden');
       if (this._headerGroup) this._headerGroup.classList.remove('is-hidden');
      };
     }
     if (y < TOP_BAND) {
      setShown();
     } else if (dy > DIR_THRESHOLD) {
      setHidden();
     } else if (dy < -DIR_THRESHOLD) {
      setShown();
     }

     this._lastY = y;
     this._ticking = false;
    });
   };
   window.addEventListener('scroll', this._onScroll, { passive: true });
   window.addEventListener('resize', () => {
    if (this._updateBodyState) this._updateBodyState();
    this._onScroll();
   }, { passive: true });
   this._onScroll();

   this._cartCountEl = this.querySelector('[data-pc-cart-count]');
   this._cartTrigger = this.querySelector('[data-pc-cart-trigger]');
   if (this._cartCountEl) {
    this._refreshCart = this._debounce(async () => {
     try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      this._cartCountEl.textContent = cart.item_count;
      this._cartCountEl.classList.toggle('is-empty', cart.item_count === 0);
      if (this._cartTrigger) {
       this._cartTrigger.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
      }
     } catch (e) { /* noop */ }
    }, 250);
    document.addEventListener('cart:refresh', this._refreshCart);
    document.addEventListener('cart:update', this._refreshCart);
   }

   if (window.Shopify && window.Shopify.designMode) {
    this._onInspectIn = () => this.classList.add('is-inspecting');
    this._onInspectOut = () => this.classList.remove('is-inspecting');
    document.addEventListener('shopify:inspector:activate', this._onInspectIn);
    document.addEventListener('shopify:inspector:deactivate', this._onInspectOut);
   }

   this._onSlideChange = (e) => {
    if (!e.target || !e.target.closest || !e.target.closest('media-gallery')) return;
    const idx = (e.detail && typeof e.detail.index === 'number') ? e.detail.index : null;
    if (idx === null) return;
    this.classList.toggle('pc-header--past-first-slide', idx > 0);
   };
   document.addEventListener('slideshow:select', this._onSlideChange);
  }

  disconnectedCallback() {
   if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
   if (this._refreshCart) {
    document.removeEventListener('cart:refresh', this._refreshCart);
    document.removeEventListener('cart:update', this._refreshCart);
   }
   if (this._onInspectIn) document.removeEventListener('shopify:inspector:activate', this._onInspectIn);
   if (this._onInspectOut) document.removeEventListener('shopify:inspector:deactivate', this._onInspectOut);
   if (this._onSlideChange) document.removeEventListener('slideshow:select', this._onSlideChange);
  }

  _debounce(fn, ms) {
   let t = null;
   return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
   };
  }
 }

 if (!customElements.get('pc-header')) {
  customElements.define('pc-header', PcHeader);
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-newsletter"] && !Shopify.designMode) return;
  try {
    
 class PcNewsletter extends HTMLElement {
  connectedCallback() {
   this.form  = this.querySelector('[data-pc-newsletter-form]');
   this.input = this.querySelector('[data-pc-newsletter-input]');
   this.status = this.querySelector('[data-pc-newsletter-status]');
   if (!this.form) return;
   this.form.addEventListener('submit', (e) => this._handleSubmit(e));
  }

  _setState(state, message) {
   this.dataset.state = state || '';
   if (this.status) {
    if (message) {
     this.status.textContent = message;
     this.status.hidden = false;
    } else {
     this.status.hidden = true;
     this.status.textContent = '';
    }
   }
  }

  async _handleSubmit(e) {
   e.preventDefault();
   const email = (this.input?.value || '').trim();
   if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    this._setState('error', 'Please enter a valid email address.');
    return;
   }
   const company = this.dataset.company;
   const list = this.dataset.list;

   // No Klaviyo configured, friendly stub message (e.g. theme preview)
   if (!company || !list || this.form.dataset.stub === 'true') {
    this._setState('success', 'Thanks, we\'ll be in touch.');
    this.input.value = '';
    return;
   }

   this._setState('loading', 'Sending…');
   try {
    const url = `https://manage.kmail-lists.com/ajax/subscriptions/subscribe`;
    const body = new URLSearchParams({
     g: list,
     email,
     $fields: '$consent',
     $list_fields: '$consent',
     $consent: 'email'
    });
    const res = await fetch(url, {
     method: 'POST',
     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
     body: body.toString(),
     mode: 'cors',
     credentials: 'omit'
    });
    // Klaviyo returns 200 even on validation errors; rely on JSON body
    const data = await res.json().catch(() => ({}));
    if (data && data.success === true) {
     this._setState('success', 'You\'re on the list. Watch your inbox.');
     this.input.value = '';
    } else if (data && data.errors && data.errors.email) {
     this._setState('error', data.errors.email[0] || 'Something went wrong. Please try again.');
    } else {
     this._setState('success', 'Thanks, we\'ll be in touch.');
     this.input.value = '';
    }
   } catch (err) {
    this._setState('error', 'Could not reach the server. Please try again.');
   }
  }
 }

 if (!customElements.get('pc-newsletter')) {
  customElements.define('pc-newsletter', PcNewsletter);
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-offer-block"] && !Shopify.designMode) return;
  try {
    
 class PcOfferBlock extends HTMLElement {
  constructor() {
   super();
   this.state = { tier: 1, qty: 1, fixingMethod: 'screws', ledVariantId: null };
  }
  connectedCallback() {
   this._bind();
   this._calcAndRender();
  }

  _bind() {
   // Tier radios
   this.querySelectorAll('[data-pc-tier-radio]').forEach(r => {
    r.addEventListener('change', () => {
     if (r.checked) {
      this.state.tier = parseInt(r.value, 10);
      this._setActiveTier();
      this._calcAndRender();
     }
    });
   });
   // Tier card click anywhere, selects radio
   this.querySelectorAll('.pc-offer-tier').forEach(card => {
    card.querySelector('.pc-offer-tier__label').addEventListener('click', (e) => {
     // Native label/radio handles toggle; nothing to do here
    });
   });

   // Quantity
   const qtyInput = this.querySelector('[data-pc-qty-input]');
   const qtyDec  = this.querySelector('[data-pc-qty-dec]');
   const qtyInc  = this.querySelector('[data-pc-qty-inc]');
   if (qtyDec) qtyDec.addEventListener('click', () => this._setQty(this.state.qty - 1));
   if (qtyInc) qtyInc.addEventListener('click', () => this._setQty(this.state.qty + 1));
   if (qtyInput) qtyInput.addEventListener('change', () => this._setQty(parseInt(qtyInput.value, 10) || 1));

   // Fixing method
   this.querySelectorAll('[name^="fixing-method-"]').forEach(r => {
    r.addEventListener('change', () => {
     if (r.checked) { this.state.fixingMethod = r.value; }
    });
   });

   // LED variant
   this.querySelectorAll('[data-pc-led-radio]').forEach(r => {
    r.addEventListener('change', () => {
     if (r.checked) {
      this.state.ledVariantId = r.value;
      const tier3 = this.querySelector('[data-pc-tier="3"]');
      if (tier3) tier3.dataset.pcLedPrice = r.dataset.pcLedPrice;
      this._calcAndRender();
     }
    });
   });
   // Set initial LED variant from default-checked radio
   const defaultLed = this.querySelector('[data-pc-led-radio][checked], [data-pc-led-radio]:checked');
   if (defaultLed) this.state.ledVariantId = defaultLed.value;

   // Add to cart
   const atc = this.querySelector('[data-pc-offer-atc]');
   if (atc) atc.addEventListener('click', (e) => this._handleAtc(e));

   this._setActiveTier();
  }

  _setActiveTier() {
   this.querySelectorAll('.pc-offer-tier').forEach(card => {
    card.dataset.pcTierActive = (parseInt(card.dataset.pcTier, 10) === this.state.tier) ? 'true' : 'false';
   });
  }

  _setQty(n) {
   n = Math.max(1, Math.min(999, n || 1));
   this.state.qty = n;
   const inp = this.querySelector('[data-pc-qty-input]');
   if (inp) inp.value = n;
   this._calcAndRender();
  }

  _calcAndRender() {
   const basePrice = parseInt(this.dataset.panelPrice, 10) || 0;
   // Per-tier price displayed under each tier card (qty-1 reference, NOT × qty)
   this.querySelectorAll('[data-pc-tier-price]').forEach(priceEl => {
    const card = priceEl.closest('.pc-offer-tier');
    const tier = parseInt(card.dataset.pcTier, 10);
    let perTier = basePrice;
    if (tier >= 2) perTier += parseInt(card.dataset.pcFixingPrice || 0, 10);
    if (tier === 3) perTier += parseInt(card.dataset.pcLedPrice || 0, 10);
    priceEl.textContent = this._formatMoney(perTier);
   });

   // Total = (active tier price) × qty
   const activeCard = this.querySelector('.pc-offer-tier[data-pc-tier-active="true"]');
   let total = basePrice;
   if (activeCard) {
    if (this.state.tier >= 2) total += parseInt(activeCard.dataset.pcFixingPrice || 0, 10);
    if (this.state.tier === 3) total += parseInt(activeCard.dataset.pcLedPrice || 0, 10);
   }
   total = total * this.state.qty;
   const totalEl = this.querySelector('[data-pc-total-amount]');
   if (totalEl) totalEl.textContent = this._formatMoney(total);
  }

  _formatMoney(cents) {
   // Simple AUD formatter, Shopify cents → "$X.YZ"
   const amount = (cents / 100).toFixed(2);
   // Use locale separator for thousands
   const [int, dec] = amount.split('.');
   const intWithCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
   return `$${intWithCommas}.${dec}`;
  }

  async _handleAtc(e) {
   e.preventDefault();
   this._setState('loading', '');
   const items = [];
   // Always: panel
   items.push({ id: parseInt(this.dataset.panelVariantId, 10), quantity: this.state.qty });
   // Tier 2 + 3: fixing kit
   if (this.state.tier >= 2) {
    const tierCard = this.querySelector(`.pc-offer-tier[data-pc-tier="${this.state.tier}"]`);
    const fixId = parseInt(tierCard?.dataset.pcFixingVariantId, 10);
    if (fixId) items.push({ id: fixId, quantity: this.state.qty });
   }
   // Tier 3: LED add-on (qty 1 regardless, a strip is a strip)
   if (this.state.tier === 3 && this.state.ledVariantId) {
    items.push({ id: parseInt(this.state.ledVariantId, 10), quantity: 1 });
   }

   try {
    const res = await fetch('/cart/add.js', {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
     body: JSON.stringify({ items })
    });
    if (!res.ok) {
     const data = await res.json().catch(() => ({}));
     throw new Error(data.description || 'Could not add to cart');
    }
    this._setState('success', 'Added to cart.');
    document.dispatchEvent(new CustomEvent('cart:update'));
    // Optional cart drawer open
    document.dispatchEvent(new CustomEvent('cart:refresh'));
   } catch (err) {
    this._setState('error', err.message || 'Could not add to cart. Please try again.');
   }
  }

  _setState(state, message) {
   this.dataset.pcState = state || '';
   const status = this.querySelector('[data-pc-offer-status]');
   if (!status) return;
   if (message) {
    status.textContent = message;
    status.hidden = false;
   } else {
    status.hidden = true;
    status.textContent = '';
   }
  }
 }

 if (!customElements.get('pc-offer-block')) {
  customElements.define('pc-offer-block', PcOfferBlock);
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  class PcTabs extends HTMLElement {
    connectedCallback() {
      this._panels = Array.from(this.querySelectorAll('[data-pc-panel]'));
      if (!this._panels.length) return;
      // Accordion headers (shown at all breakpoints): toggle their own panel independently.
      this.querySelectorAll('.pc-tab-mtrigger').forEach((trig) => {
        trig.addEventListener('click', () => this.toggle(trig.dataset.pcTab));
      });
      // Hidden legacy top-nav buttons (nav is not displayed) — open the matching panel if used.
      this.querySelectorAll('.pc-tab').forEach((tab) => {
        tab.addEventListener('click', () => this.setOpen(this.panelFor(tab.dataset.pcTab), true));
      });
    }
    panelFor(name) { return this._panels.find((p) => p && p.dataset.pcPanel === name); }
    setOpen(panel, open) {
      if (!panel) return;
      panel.classList.toggle('is-active', open);
      const trig = panel.querySelector('.pc-tab-mtrigger');
      if (trig) trig.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggle(name) {
      const panel = this.panelFor(name);
      if (panel) this.setOpen(panel, !panel.classList.contains('is-active'));
    }
  }
  if (!customElements.get('pc-tabs')) { customElements.define('pc-tabs', PcTabs); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class PcReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this._timer = null;
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._onScrollDebounced = null;
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-pc-reviews-viewport]');
      this.track = this.querySelector('[data-pc-reviews-track]');
      this.prevBtn = this.querySelector('[data-pc-reviews-prev]');
      this.nextBtn = this.querySelector('[data-pc-reviews-next]');
      this.dotsContainer = this.querySelector('[data-pc-reviews-dots]');
      if (!this.track || !this.dotsContainer) return;

      this.slides = Array.from(this.track.querySelectorAll('.pc-reviews__slide'));
      this._buildDots();
      this._bindControls();
      this._updateState();

      if (this.dataset.autoplay === 'true' && !this._reducedMotion.matches) {
        this._startTimer();
        this.addEventListener('mouseenter', () => this._stopTimer());
        this.addEventListener('mouseleave', () => this._startTimer());
        this.addEventListener('focusin', () => this._stopTimer());
      }

      // Editor mode: pause when section/block selected
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:section:select', () => this._stopTimer());
        this.addEventListener('shopify:section:deselect', () => this._startTimer());
        this.addEventListener('shopify:block:select', (e) => {
          this._stopTimer();
          const idx = this.slides.indexOf(e.target.closest('.pc-reviews__slide'));
          if (idx >= 0) this._scrollTo(idx);
        });
      }
    }

    disconnectedCallback() {
      this._stopTimer();
    }

    _buildDots() {
      this.dotsContainer.innerHTML = '';
      this._dotCount = this._calcDotCount();
      for (let i = 0; i < this._dotCount; i++) {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `Go to review page ${i + 1}`);
        btn.addEventListener('click', () => this._scrollToPage(i));
        li.appendChild(btn);
        this.dotsContainer.appendChild(li);
      }
    }

    _perPage() {
      const slide = this.slides[0];
      if (!slide) return 1;
      const slideW = slide.getBoundingClientRect().width;
      const viewW = this.viewport.getBoundingClientRect().width;
      return Math.max(1, Math.round(viewW / slideW));
    }

    _calcDotCount() {
      const per = this._perPage();
      return Math.max(1, Math.ceil(this.slides.length / per));
    }

    _bindControls() {
      this.prevBtn?.addEventListener('click', () => this._step(-1));
      this.nextBtn?.addEventListener('click', () => this._step(1));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._onScrollDebounced);
        this._onScrollDebounced = setTimeout(() => this._updateState(), 80);
      }, { passive: true });
      window.addEventListener('resize', () => {
        this._buildDots();
        this._updateState();
      });
    }

    _stride() {
      const slide = this.slides[0];
      return slide ? slide.getBoundingClientRect().width + 16 : 1; // slide width + gap
    }

    _maxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    _currentIndex() {
      return Math.round(this.track.scrollLeft / this._stride());
    }

    // Current page (0-based) among the dot pages, with the clamped end mapped
    // to the final page so the last dot always activates.
    _currentPage() {
      const per = this._perPage();
      const pages = this._calcDotCount();
      const max = this._maxScroll();
      const sl = this.track.scrollLeft;
      if (max <= 1) return 0;
      if (sl >= max - 2) return pages - 1;              // scrolled to the end
      return Math.min(pages - 1, Math.round(sl / (this._stride() * per)));
    }

    // Scroll so page `i` is shown. The final page scrolls to the true end
    // (the scroller can't put the last item flush-left when it doesn't fill a page).
    _scrollToPage(i) {
      const pages = this._calcDotCount();
      i = Math.max(0, Math.min(pages - 1, i));
      const max = this._maxScroll();
      let target = i * this._perPage() * this._stride();
      if (i >= pages - 1) target = max;
      target = Math.min(target, max);
      if (this._reducedMotion.matches) { this.track.scrollLeft = target; return; }
      this._animateScroll(target);
    }

    _scrollTo(index) {
      if (index < 0) index = 0;
      if (index > this.slides.length - 1) index = this.slides.length - 1;
      const slide = this.slides[0];
      if (!slide) return;
      const stride = slide.getBoundingClientRect().width + 16; // slide width + gap
      const target = index * stride;
      // Mandatory scroll-snap cancels the browser's native smooth scrollTo, so we
      // animate scrollLeft ourselves with snap momentarily disabled.
      if (this._reducedMotion.matches) { this.track.scrollLeft = target; return; }
      this._animateScroll(target);
    }

    _animateScroll(target) {
      const el = this.track;
      const start = el.scrollLeft;
      const dist = target - start;
      if (Math.abs(dist) < 1) { el.scrollLeft = target; return; }
      const duration = 360;
      const startTime = performance.now();
      const prevSnap = el.style.scrollSnapType;
      el.style.scrollSnapType = 'none';
      cancelAnimationFrame(this._raf);
      const ease = (p) => 1 - Math.pow(1 - p, 3);
      const tick = (now) => {
        const p = Math.min(1, (now - startTime) / duration);
        el.scrollLeft = start + dist * ease(p);
        if (p < 1) {
          this._raf = requestAnimationFrame(tick);
        } else {
          el.style.scrollSnapType = prevSnap || '';
        }
      };
      this._raf = requestAnimationFrame(tick);
    }

    _step(delta) {
      this._scrollToPage(this._currentPage() + delta);
    }

    _updateState() {
      const page = this._currentPage();
      const pages = this._calcDotCount();
      this.dotsContainer.querySelectorAll('button').forEach((b, i) => {
        b.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
      this.prevBtn?.setAttribute('aria-disabled', page === 0 ? 'true' : 'false');
      this.nextBtn?.setAttribute('aria-disabled', page >= pages - 1 ? 'true' : 'false');
    }

    _startTimer() {
      const interval = parseInt(this.dataset.interval, 10);
      if (!interval || isNaN(interval)) return;
      this._stopTimer();
      this._timer = setInterval(() => {
        const page = this._currentPage();
        if (page >= this._calcDotCount() - 1) {
          this._scrollToPage(0);
        } else {
          this._scrollToPage(page + 1);
        }
      }, interval);
    }

    _stopTimer() {
      if (this._timer) { clearInterval(this._timer); this._timer = null; }
    }
  }

  if (!customElements.get('pc-reviews-carousel')) {
    customElements.define('pc-reviews-carousel', PcReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  class PcUgcCarousel extends HTMLElement {
    connectedCallback() {
      this._track  = this.querySelector('[data-pc-ugc-track]');
      this._cards  = Array.from(this.querySelectorAll('[data-pc-ugc-card]'));
      this._prev   = this.querySelector('[data-pc-ugc-prev]');
      this._next   = this.querySelector('[data-pc-ugc-next]');
      if (!this._track || !this._cards.length) return;

      this._cards.forEach((card) => {
        const playBtn = card.querySelector('[data-pc-ugc-play]');
        const video   = card.querySelector('[data-pc-ugc-video]');
        const media   = card.querySelector('.pc-ugc-card__media');
        if (!media) return;

        const togglePlay = (e) => {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          if (!video) return;
          if (card.classList.contains('is-playing')) {
            video.pause();
          } else {
            this.playOnly(card);
          }
        };

        if (playBtn) playBtn.addEventListener('click', togglePlay);
        media.addEventListener('click', togglePlay);

        if (video) {
          video.addEventListener('play',  () => card.classList.add('is-playing'));
          video.addEventListener('pause', () => card.classList.remove('is-playing'));
          video.addEventListener('ended', () => card.classList.remove('is-playing'));
        }
      });

      const scrollByCard = (dir) => {
        const card = this._cards[0];
        if (!card) return;
        const step = card.getBoundingClientRect().width + 16;
        this._track.scrollBy({ left: dir * step, behavior: 'smooth' });
      };
      if (this._prev) this._prev.addEventListener('click', () => scrollByCard(-1));
      if (this._next) this._next.addEventListener('click', () => scrollByCard(1));

      const updateNavVisibility = () => {
        const { scrollLeft, scrollWidth, clientWidth } = this._track;
        const atStart = scrollLeft <= 2;
        const atEnd   = scrollLeft + clientWidth >= scrollWidth - 2;
        if (this._prev) this._prev.hidden = atStart;
        if (this._next) this._next.hidden = atEnd;
      };
      this._track.addEventListener('scroll', updateNavVisibility, { passive: true });
      window.addEventListener('resize', updateNavVisibility, { passive: true });
      requestAnimationFrame(updateNavVisibility);
    }

    playOnly(card) {
      this._cards.forEach((c) => {
        const v = c.querySelector('[data-pc-ugc-video]');
        if (!v) return;
        if (c === card) {
          v.play().catch(() => { });
        } else {
          v.pause();
          c.classList.remove('is-playing');
        }
      });
    }
  }
  if (!customElements.get('pc-ugc-carousel')) {
    customElements.define('pc-ugc-carousel', PcUgcCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
